import {
  Layout,
  Typography,
} from "@visma-netvisor/react-component-library";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useServiceNeedContext, QuestionSteps } from "../../context/ServiceNeedContext";
import {
  HolviServiceNeedPage,
  InsuranceServiceNeedPage,
  AccountingServiceNeedPage,
} from "./Pages";

const ServicePageSelector = ({
  initialPage,
  finalPage,
}: {
  initialPage: React.ComponentType;
  finalPage: React.ComponentType;
}) => {
  const { questionStep } = useServiceNeedContext();
  const SelectedPage = questionStep === QuestionSteps.INITIAL ? initialPage : finalPage;
  
  return (
    <Layout.Flex flexDirection="column" flexGap={0}>
      <SelectedPage />
    </Layout.Flex>
  );
};

const AccountingServiceNeedForm = () => {
  const { questionStep, isThisANewCompany } = useServiceNeedContext();
  const { t } = useTranslation();

  return (
    <>
      <StyledTypography
        as="h3"
        color="secondary"
        variant="headingH3Semibold"
        styleOverrides={{ textAlign: "center" }}
      >
        {questionStep === QuestionSteps.INITIAL
          ? t("OnlineStatus.AFewMoreQuestions")
          : null}
      </StyledTypography>
      {isThisANewCompany ? (
        <ServicePageSelector
          initialPage={HolviServiceNeedPage}
          finalPage={InsuranceServiceNeedPage}
        />
      ) : (
        <ServicePageSelector
          initialPage={AccountingServiceNeedPage}
          finalPage={InsuranceServiceNeedPage}
        />
      )}
    </>
  );
};

export default AccountingServiceNeedForm;

const StyledTypography = styled(Typography)`
  @media (max-width: 768px) {
    font-size: 20px;
    padding-bottom: 80px;
  }
`;
